// removed by extract-text-webpack-plugin
module.exports = {"container":"styles-module__container___1NT7l"};


//////////////////
// WEBPACK FOOTER
// ./src/core/components/FilterOption/styles.module.css
// module id = 500
// module chunks = 0